export default "__VITE_ASSET__BC8L0bte__"